var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileCsv(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_45012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.502 46.5078H4.50195C3.7063 46.5078 2.94324 46.1917 2.38063 45.6291C1.81802 45.0665 1.50195 44.3035 1.50195 43.5078V4.50781C1.50195 3.71216 1.81802 2.9491 2.38063 2.38649C2.94324 1.82388 3.7063 1.50781 4.50195 1.50781H25.76C26.555 1.50798 27.3176 1.82378 27.88 2.38581L39.624 14.1278C39.9025 14.4065 40.1234 14.7374 40.274 15.1015C40.4247 15.4656 40.5021 15.8558 40.502 16.2498V25.5078",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.502 16.5078H28.502C27.7063 16.5078 26.9432 16.1917 26.3806 15.6291C25.818 15.0665 25.502 14.3035 25.502 13.5078V1.50781",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.502 31.5078C20.9107 31.5078 19.3845 32.14 18.2593 33.2652C17.1341 34.3904 16.502 35.9165 16.502 37.5078V40.5078C16.502 42.0991 17.1341 43.6252 18.2593 44.7505C19.3845 45.8757 20.9107 46.5078 22.502 46.5078",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.502 31.5078H31.502C30.7063 31.5078 29.9432 31.8239 29.3806 32.3865C28.818 32.9491 28.502 33.7122 28.502 34.5078C28.502 39.0078 34.502 39.0078 34.502 43.5078C34.502 44.3035 34.1859 45.0665 33.6233 45.6291C33.0607 46.1917 32.2976 46.5078 31.502 46.5078H28.502",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.502 31.5078V36.5998C40.5021 40.1268 41.5459 43.5749 43.502 46.5098C45.458 43.5749 46.5018 40.1268 46.502 36.5998V31.5078",
    stroke: "#1F76FF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_45012"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCsv);
export default __webpack_public_path__ + "static/media/FileCSV.efb3e38f0c1a58b9c4e52219598a8a88.svg";
export { ForwardRef as ReactComponent };